import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import iconSprite from '../../../assets/icon-sprite.svg';

class LoanScheduleTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.data?.id !== this.props?.data?.id) {
      // if needs be, fetch fresh data.
    }
  }

  render() {
    const { visible, onClose = function $() { }, data } = this.props;
    console.log(data)
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Loan Schedule Transactions</h5>
            <button type="button" className="close" onClick={onClose}>
              <svg width="48" height="48">
                <use xlinkHref={iconSprite + '#close-icon'}></use>
              </svg>
            </button>
          </div>
          <div className="modal-body">
            {data?.loan_transactions && <div className="row">
              {data?.loan_transactions.length && <div className="col">
                <div className="card default-card settings">

                  <div className="table-responsive">
                    <table className="table" style={{ textAlign: 'center' }}>
                      <thead className="bg-secondary">
                        <tr>
                          <th className="amount text-white">Amount</th>
                          <th className="description text-white">Description</th>
                          <th className="status text-white">Status</th>
                          <th className="date-time text-white">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.loan_transactions.map((tran) => (
                          <tr key={tran.id}>
                            <td className="amount">
                            ₦{Number(tran['amount']).toLocaleString()}
                            </td>
                            <td className="description">
                              {tran['meta']}
                            </td>
                            <td className="status">
                              {tran['status']}
                            </td>
                            <td className="date-time">
                              <span className="date">{moment(tran.created_on).format('MMM DD, YYYY')}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}
            </div>}
            {!data?.loan_transactions && <center>No transactions found</center>}
          </div>
        </div>
      </Modal>
    );
  }
}

export default LoanScheduleTransactions;
